// 쿠키에서 토큰 가져오기
export const getTokenFromCookie = () => {
  const cookies = document.cookie.split(';');
  const tokenCookie = cookies.find((cookie) => cookie.trim().startsWith('auth_token='));
  return tokenCookie ? tokenCookie.split('=')[1] : null;
};

// 쿠키에 토큰 설정
export const setTokenCookie = (token: string, domain: string) => {
  document.cookie = `auth_token=${token}; domain=${domain}; path=/; max-age=3600; secure`; // 1시간 유효
};

// 쿠키에서 토큰 삭제
export const removeTokenCookie = (domain: string) => {
  document.cookie = `auth_token=; domain=${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};

// auth_token 쿠키를 현재 호스트와 상위 도메인 전체에서 삭제한다.
// (예: 운영(.bubblechat.ai) 토큰이 staging 서브도메인까지 전달되어 cross-env 401(aud 불일치)을
//  유발하는 경우, .staging.bubblechat.ai 로는 부모 도메인 쿠키를 못 지우므로 상위 도메인까지 정리한다.)
export const clearAuthToken = () => {
  const { hostname } = window.location;
  const parts = hostname.split('.');
  const domains = new Set<string>(['']); // domain 속성 없는 쿠키도 제거

  // staging.bubblechat.ai → ['staging.bubblechat.ai', 'bubblechat.ai'] 누적
  for (let i = 0; i < parts.length - 1; i += 1) {
    const domain = parts.slice(i).join('.');
    domains.add(domain);
    domains.add(`.${domain}`);
  }

  domains.forEach((domain) => {
    const domainAttr = domain ? ` domain=${domain};` : '';
    document.cookie = `auth_token=;${domainAttr} path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  });
};
